import React, { useState, useEffect } from 'react';
import { TfiMenu } from "react-icons/tfi";
import { IoCall } from "react-icons/io5";
import { BsBehance, BsFillCaretDownFill } from "react-icons/bs";
import { AiFillInstagram, } from "react-icons/ai";
import { FaFacebookF, FaLinkedinIn, FaWheelchair } from "react-icons/fa6"
import { TfiYoutube } from "react-icons/tfi";
import { MdOutlineWebAsset, MdOutlineMoveDown, MdOutlineAnalytics, MdOutlineShoppingCart, MdOutlineDesignServices, MdOutlineSearch, MdOutlineAccountTree, MdOutlinePeople, MdOutlineShare } from 'react-icons/md';
import { BsPhoneFlip, BsInfoCircle, BsBriefcase, BsBoxSeam, BsPeople, BsCloud } from 'react-icons/bs';
import { BsMicrosoft } from 'react-icons/bs';
import { RiRobot2Line } from 'react-icons/ri';
import { FaCloud } from 'react-icons/fa';
import { TbSettingsAutomation } from 'react-icons/tb';
import './header.css';
import Animatedcursor from '../Animecursor/animatedcursor';
import Countryselect from '../Countryselect/countryselect';
import ModernMegaMenu from '../Megamenu/ModernMegaMenu';






function HeaderAU() {
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isMobileSubMenuOpen, setMobileSubMenuOpen] = useState(false);
    const [isMobileSocialOpen, setMobileSocialOpen] = useState(false);
    const [isMobileProductsOpen, setMobileProductsOpen] = useState(false);
    const [megaProjectImages, setMegaProjectImages] = useState([]);

    useEffect(() => {
        fetch(`/json_files/megaproject.json?v=${Date.now()}`)
            .then((res) => res.json())
            .then((data) => {
                const active = data
                    .filter((p) => p.isActive !== false)
                    .map((p) => ({ image: p.image, name: p.title || p.name || '', url: p.url || '/projects' }));
                setMegaProjectImages(active);
            })
            .catch(() => {});
    }, []);

    const openMobileMenu = () => {
        setMobileMenuOpen(true);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };
    const toggleMobileSubMenu = () => {
        setMobileSubMenuOpen(!isMobileSubMenuOpen);
    };

    const toggleMobileSocial = () => {
        setMobileSocialOpen(!isMobileSocialOpen);
    };

    const toggleMobileProducts = () => {
        setMobileProductsOpen(!isMobileProductsOpen);
    };

    // ModernMegaMenu data for Services
    const modernServicesData = {
        columns: [
            {
                title: "Core Services",
                items: [
                    { icon: <MdOutlineWebAsset />, title: 'Web Development', link: '/web-design', description: 'Custom websites built for performance and growth.' },
                    { icon: <BsPhoneFlip />, title: 'App Development', link: '/appdevelopment', description: 'Native and cross-platform mobile apps.' },
                    { icon: <RiRobot2Line />, title: 'Artificial Intelligence', link: '/artificialintelligence', description: 'AI solutions tailored to your business needs.' },
                    { icon: <MdOutlineShoppingCart />, title: 'Ecommerce', link: '/ecommerce', description: 'End-to-end online store design and development.' },
                    { icon: <TbSettingsAutomation />, title: 'Automation', link: '/automation', description: 'Streamline workflows and reduce manual effort.' },
                ]
            },
            {
                title: "Specialized",
                items: [
                    { icon: <MdOutlineMoveDown />, title: 'Migration Services', link: '/migrationservices', description: 'Seamless platform and data migrations.' },
                    { icon: <MdOutlineAnalytics />, title: 'Data Analytics', link: '/dataanalytics', description: 'Insights from your data to drive decisions.' },
                    { icon: <FaCloud />, title: 'Cloud Services', link: '/cloudservices', description: 'Scalable cloud infrastructure and management.' },
                      { icon: <MdOutlineAccountTree />, title: 'ERP Solutions', link: '/erp', description: 'Unify your business processes end-to-end.' },
                    { icon: <MdOutlinePeople />, title: 'CRM Solutions', link: '/crm', description: 'Manage and grow customer relationships.' },
                ]
            },
            {
                title: "Creative",
                items: [
                    { icon: <MdOutlineDesignServices />, title: 'Design Works', link: '/design', description: 'Brand, UI/UX, and graphic design.' },
                    { icon: <MdOutlineSearch />, title: 'SEO', link: '/seo', description: 'Search engine optimisation for organic growth.' },
                    { icon: <MdOutlineShare />, title: 'Social Media', link: '/socialmedia', description: 'Grow your brand across Facebook, Instagram & YouTube.' },
                  
                ]
            }
        ],
        highlight: {
            title: "Our Work",
            subtitle: "Explore projects we've delivered for Australian and global clients.",
            mediaType: megaProjectImages.length > 0 ? 'slider' : 'image',
            mediaSrc: '/assets/img/about/about-1.jpg',
            images: megaProjectImages,
            actionText: 'View All Projects',
            actionLink: '/projects'
        }
    };

    // ModernMegaMenu data for Company
    const modernCompanyData = {
        columns: [
            {
                title: "Company",
                items: [
                    { icon: <BsInfoCircle />, title: 'About Us', link: '/about', description: 'Our story, mission, and team in Australia.' },
                    { icon: <BsBriefcase />, title: 'Careers', link: '/career', description: 'Join our growing Australian team.', badge: "We're hiring!" },
                    { icon: <BsMicrosoft />, title: 'Microsoft Partner', link: '/microsoft', description: 'Certified Microsoft 365 solutions partner.' },
                ]
            }
        ],
        highlight: {
            title: "Get In Touch",
            subtitle: "Ready to grow your business in Australia? Let's talk.",
            mediaType: 'image',
            mediaSrc: '/assets/img/about/about-2.jpg',
            actionText: 'Contact Us',
            actionLink: '/contact'
        }
    };

    // ModernMegaMenu data for Products
    const modernProductsData = {
        columns: [
            {
                title: "Business Solutions",
                items: [
                    { icon: <BsBoxSeam />, title: 'Accounting', link: '/accounting-boox', description: 'Comprehensive accounting solution for modern businesses.' },
                    { icon: <BsPeople />, title: 'HRMS', link: '/hr-boox', description: 'Human Resource Management System for efficient teams.' },
                    { icon: <BsCloud />, title: 'WeCaaS', link: '/wecaas', description: 'Web/Website as a Service, cloud hosting & solutions.' },
                ]
            }
        ],
        highlight: {
            title: "Innovating the Future",
            subtitle: "Check out our latest product releases and digital solutions.",
            mediaType: 'image',
            mediaSrc: '/assets/img/about/about-1.jpg',
            actionText: 'View All Products',
            actionLink: '/service'
        }
    };

    return (
        <div>
            {/* <Animatedcursor/> */}
            <header className='header1' id="header1">
                <div className="tp-header-area tp-header-transparent tp-header-height theme-bg home-banner" id="header1">
                    <div className="container">
                        <div className="tp-header-box">
                            <div className="row align-items-center">
                                <div className="col-xl-2 col-lg-6 col-md-6 col-6">
                                    <div className="logo">
                                        <a href="/">
                                            <img data-width="115" src="/assets/img/logo/dgilogo/dgi.png" alt="" loading='lazy' />
                                        </a>
                                    </div>
                                </div>
                                <div className="col-xl-9 d-none d-xl-block">
                                    <div className="main-menu">
                                        <nav id="mobile-menu" className="tp-main-menu-content">
                                            <ul>
                                                <li className=" tp-static">
                                                    <a href="/">Home</a>
                                                </li>
                                                <ModernMegaMenu title="Company" data={modernCompanyData} />
                                                <ModernMegaMenu title="Our Services" data={modernServicesData} />
                                                <ModernMegaMenu title="Products" data={modernProductsData} />
                                                <li className=" tp-static">
                                                    <a href="/projects">Projects</a>
                                                </li>
                                                <li className=" tp-static">
                                                    <a href="/ndis-website-design">
                                                        <span className=''><FaWheelchair /></span>NDIS</a>
                                                </li>
                                                {/* <li className="tp-static fire-gif">
                                                    <span className=''><img src="/assets/img/fire/fire-1.gif"></img></span>
                                                    <a href="/dgiginite" className='fire-dgi'>DGignite</a>
                                                </li> */}
                                                <li><a href="/contact">Contact</a></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                <div className="col-xl-1 col-lg-6 col-md-6 col-6">
                                    <div className="tp-header-right d-flex align-items-center justify-content-end">
                                        {/* <div className="tp-header-search">
                                            
                                            <span><img src="/assets/img/flags/au.png" alt="" loading='lazy'></img></span>
                                            <span>AU</span>
                                        </div> */}
                                        <div className="tp-header-search">
                                            <Countryselect />
                                        </div>

                                        <div className="offcanvas-btn d-xl-none ml-20">
                                            <button className="offcanvas-open-btn"><i><TfiMenu className="fa-solid fa-bars" onClick={openMobileMenu} /></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* nav bar 2 */}
            <header className='header2' id="header2">
                <div className="tp-header-area tp-header-3 tp-header-height" >
                    <div id="header-sticky" className="tp-header-3-wrap white-bg d-flex justify-content-between">
                        <div className="tp-header-3-main d-flex">
                            <div className="logo" data-background="/assets/img/shape/logo-shape-1.png">
                                <a href="/">
                                    <img data-width="115" src="/assets/img/logo/dgilogo/dgilogo-2.png" alt="" />
                                </a>
                            </div>
                            <div className="main-menu tp-header-3-menu d-none d-xl-block">
                                <nav id="mobile-menu" className="tp-main-menu-content">
                                    <ul>
                                        <li className=" tp-static">
                                            <a href="/">Home</a>
                                        </li>
                                        <ModernMegaMenu title="Company" data={modernCompanyData} />
                                        <ModernMegaMenu title="Our Services" data={modernServicesData} />
                                        <ModernMegaMenu title="Products" data={modernProductsData} />
                                        <li className=" tp-static">
                                            <a href="/projects">Projects</a>
                                        </li>
                                        <li className=" tp-static">
                                            <a href="/ndis-website-design">
                                                <span className=''><FaWheelchair /></span>NDIS</a>
                                        </li>
                                        {/* <li className="tp-static fire-gif">
                                            <span className=''><img src="/assets/img/fire/fire.gif"></img></span>
                                            <a href="/dgiginite" className='fire-dgi'>DGignite</a>
                                        </li> */}
                                        <li><a href="/contact">Contact</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div className="tp-header-right d-flex align-items-center">
                            {/* <div className="tp-header-search2 ">
                                
                                <span><img src="/assets/img/flags/au.png" alt="" loading='lazy'></img></span>
                                <span>AU</span>
                            </div> */}
                            <div className="tp-header-search2">
                                <Countryselect />
                            </div>
                            <div className="d-none d-md-block">
                                <div className="tp-header-4-contact d-flex align-items-center">
                                    <div className="tp-header-4-contact-icon">
                                        <i><IoCall className="fa-solid fa-phone-flip" /></i>
                                    </div>
                                    <div className="tp-header-4-contact-content">
                                        <span>Call </span>
                                        <a href="tel:+610452573682">+61 0452573682</a>
                                    </div>
                                </div>
                            </div>
                            <div className="offcanvas-btn d-xl-none ml-30">
                                <button className="offcanvas-open-btn"><i><TfiMenu className="fa-solid fa-bars offcanvas-open-btn" onClick={openMobileMenu} /></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* <!-- offcanvas area start --> */}
            <div className={`offcanvas__area ${isMobileMenuOpen ? 'offcanvas-opened' : ''}`}>
                <div className="offcanvas__wrapper">
                    <div className="offcanvas__close">
                        <button className="offcanvas__close-btn offcanvas-close-btn" onClick={closeMobileMenu}>
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11 1L1 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M1 1L11 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                    </div>
                    <div className="offcanvas__content">
                        <div className="offcanvas__top mb-70 d-flex justify-content-between align-items-center">
                            <div className="offcanvas__logo logo">
                                <a href="/">
                                    <img dataWidth="115" src="/assets/img/logo/dgilogo/dgilogo-2.png" alt="" />
                                </a>
                            </div>
                            {/* <div className="tp-header-search">
                                <Countryselect className="countryselect" />
                                <span><img src="/assets/img/flags/au.png" alt="" loading='lazy'></img></span>
                                <span>AU</span>
                            </div> */}
                            <div className="tp-header-search2">
                                <Countryselect />
                            </div>
                        </div>
                        <div className="tp-main-menu-mobile">
                            <nav id="mobile-menu" className="tp-main-menu-content">
                                <ul>
                                    <li className=" tp-static">
                                        <a href="/">Home</a>
                                    </li>
                                    <li className=" tp-static">
                                        <a href="/about">About</a>
                                    </li>
                                    <li className="has-dropdown" >
                                        <a href="#" onClick={toggleMobileSubMenu} >Our Services
                                            <button className="dropdown-toggle-btn" id="submenu"><i ><BsFillCaretDownFill onClick={toggleMobileSubMenu} /></i></button>
                                        </a>

                                        <ul className={`tp-submenu ${isMobileSubMenuOpen ? 'mobilesubmenu-opened' : ' '}`}>
                                            <li><a href="/web-design">Web Development</a></li>
                                            <li><a href="/appdevelopment">App Development </a></li>
                                            <li><a href="/artificialintelligence">Artificial Intelligence</a></li>
                                            <li><a href="/cloudservices">Cloud Services</a></li>
                                            
                                            <li><a href="/automation">Automation</a></li>
                                            <li><a href="/migrationservices">Migration Services</a></li>
                                            <li><a href="/dataanalytics">Data Analytics</a></li>
                                            <li><a href="/ecommerce">Ecommerce</a></li>
                                            <li><a href="/design">Design Works </a></li>
                                            {/* <li><a href="/socialmedia">Social Media</a></li> */}
                                            <li className=""><a href="/seo">SEO</a></li>
                                        </ul>
                                    </li>
                                    <li className="has-dropdown">
                                        <a href="#" onClick={(e) => { e.preventDefault(); toggleMobileProducts(); }}>
                                            Products
                                            <button className="dropdown-toggle-btn"><i><BsFillCaretDownFill onClick={toggleMobileProducts} /></i></button>
                                        </a>
                                        <ul className={`tp-submenu ${isMobileProductsOpen ? 'mobilesubmenu-opened' : ''}`}>
                                            <li><a href="/accounting-boox">Boox365 Accounting</a></li>
                                            <li><a href="/hr-boox">Boox365 HRMS</a></li>
                                            <li><a href="/wecaas">WeCaaS</a></li>
                                        </ul>
                                    </li>
                                    <li className=" tp-static">
                                        <a href="/projects">Projects</a>
                                    </li>
                                    <li className=" tp-static">
                                        <a href="/ndis-website-design">
                                            <span className=''><FaWheelchair /></span>NDIS</a>
                                    </li>
                                    {/* <li className="tp-static fire-gif-mobile ">

                                        <img src="/assets/img/fire/fire.gif" className='gif-min'></img>
                                        <a href="/dgiginite" className='fire-dgi'>DGignite</a>

                                    </li> */}

                                    <li><a href="/contact">Contact</a></li>
                                </ul>
                            </nav>
                        </div>
                        {/* <div className="offcanvas__btn">
                            <a href="#" className="tp-btn">Getting Started</a>
                        </div>
                        <div className="side-info-contact">
                            <span>we are here</span>
                            <p>1489 Langley Ave <br /> Grand Forks Afb, North.</p>
                        </div> */}
                        <div className="side-info-social">
                            <a href="https://www.linkedin.com/company/67087770/" target="_blank"><i><FaLinkedinIn className="fa-brands fa-linkedin-in" /></i></a>
                            <a href="https://www.facebook.com/dgiworx" target="_blank"><i><FaFacebookF className="fa-brands fa-facebook-f" /></i></a>
                            <a href="https://www.instagram.com/dgiworx/" target="_blank"><i> <AiFillInstagram className="fa-brands fa-instagram" /></i></a>
                            <a href="https://www.behance.net/dgiworx" target="_blank"><i ><BsBehance className="fa-brands fa-twitter" /></i></a>
                            <a href="https://www.youtube.com/channel/UCxN2y-6L8tL_ZNXYPq8_n3g" target="_blank"><i><TfiYoutube className="fa-brands fa-youtube-f" /></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`body-overlay ${isMobileMenuOpen ? 'opened' : ''}`}></div>
        </div>
    )
}

export default HeaderAU;